import{v as e,w as o,z as r}from"../chunk-4G6ZGMDP.js";import"../chunk-AXXYPYMM.js";e.isCreated()||e.createContext();export{o as mudCoreConfig,r as resolveTableId};
//# sourceMappingURL=index.js.map